import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onCreateListing }) => {
  return (
    <div className="bg-card rounded-xl p-8 md:p-12 text-center shadow-organic border border-border">
      <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
        <Icon name="Package" size={40} className="text-muted-foreground" />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
        Henüz İlan Bulunamadı
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Aradığınız kriterlere uygun ilan bulunamadı. Filtreleri değiştirerek tekrar deneyin veya kendi ilanınızı oluşturun.
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
        <Button
          variant="default"
          iconName="Plus"
          iconPosition="left"
          onClick={onCreateListing}
        >
          İlan Oluştur
        </Button>
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={() => window.location?.reload()}
        >
          Filtreleri Sıfırla
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;